export const NIFC_DATE_FIELD = 'run_time';

export type NifcStatsFeature = {
  properties: {
    incidentname: string;
    run_time: string;
    createdate: string;
  };
};
